import axios from "axios";
import Response from "../../models/response";
import config from "../config";

export const appJsonContentTypeHeader = (token) => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});
export async function getBasicChartData(col, op, val) {
  let basicChartdata = axios
    .get(
      `${config.base_url}/home/basicChart?col=${col}&op=${op}&val=${val}`,
      appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return basicChartdata;
}
export async function getUnitTypesChart(col, op, val) {
  let unitTypesChart = axios
    .get(
      `${config.base_url}/home/unitTypesChart?col=${col}&op=${op}&val=${val}`,
      appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return unitTypesChart;
}

export async function getAirFlowChart(col, op, val) {
  let airflowChart = axios
    .get(
      `${config.base_url}/home/airFlowChart?col=${col}&op=${op}&val=${val}`,

      appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return airflowChart;
}

export async function getTypesAndCostsChartData(col, op, val) {
  let unitsChart = axios
    .get(
      `${config.base_url}/home/unitCostsChart?col=${col}&op=${op}&val=${val}`,

      appJsonContentTypeHeader(localStorage.getItem("jwt"))
    )
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      err = err.response;
      return new Response(err.status, err.data.message);
    });
  return unitsChart;
}
